<template>
  <div class="page-contact" v-if="contactAs">
    <el-tooltip effect="dark" content="联系我们" placement="left">
      <a
        target="_blank"
        :href="
          `http://popo.netease.com/static/html/open_popo.html?ssid=${contactAs}&sstp=0`
        "
      >
        <img class="pc-icon" src="/img/popo.png" />
      </a>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  components: {},
  data () {
    return {}
  },
  created () {
    this.init()
  },
  computed: {
    contactAs () {
      return this.$store.getters['app/contactAs']
    }
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {}
  }
}
</script>
<style lang="scss">
@import 'page-contact';
</style>
